import { render, staticRenderFns } from "./downtimePercentage.vue?vue&type=template&id=79023848&scoped=true&"
import script from "./downtimePercentage.vue?vue&type=script&lang=js&"
export * from "./downtimePercentage.vue?vue&type=script&lang=js&"
import style0 from "./downtimePercentage.vue?vue&type=style&index=0&id=79023848&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79023848",
  null
  
)

export default component.exports